export default __webpack_public_path__ + "static/media/img_case_ex3.43ecb600.png";